module.exports = __webpack_public_path__ + "static/media/1en.10f6dfa3.jpg";